import Common from '../../Common';

const Provisioning = class extends Common {
	read = (userId: number): CustomResponse<Provisioning> =>
		this.get(`/user/${userId}/provisioning`)
}

export default Provisioning;
